export default function(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/node_modules/topojson-client/src/reverse.js
// module id = Aynv
// module chunks = 0